var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 14.0002H13.3334M3.77741 8.79156C3.49303 9.07637 3.33334 9.46241 3.33341 9.86489V12.0002H5.48208C5.88475 12.0002 6.27075 11.8402 6.55541 11.5549L12.8887 5.21822C13.1732 4.93346 13.333 4.54741 13.333 4.14489C13.333 3.74237 13.1732 3.35632 12.8887 3.07156L12.2634 2.44489C12.1224 2.30379 11.9549 2.19187 11.7706 2.11554C11.5863 2.0392 11.3888 1.99994 11.1893 2C10.9898 2.00006 10.7923 2.03944 10.608 2.1159C10.4237 2.19235 10.2564 2.30437 10.1154 2.44556L3.77741 8.79156Z",
    stroke: "#7C63A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodEdit);
export default __webpack_public_path__ + "static/media/mood-edit.9c3725c46d2b174e26c0950354a10f53.svg";
export { ForwardRef as ReactComponent };